import React, { Fragment, useCallback, useState } from 'react';
import Modal from '../../common/modal/Modal';
import { ModalType } from '../../../models/ModalType';
import styled from 'styled-components';
import sassVar from '../../../styles/variables.module.scss';

const { deleteReportModalWidth, fontInterstate } = sassVar;

type ConfirmationSourceModalProps = {
  show: boolean;
  handleContinueClick: () => void;
  handleNoClick: () => void;
};

const ConfirmationSourceModal: React.FC<ConfirmationSourceModalProps> = ({
  show,
  handleContinueClick,
  handleNoClick
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal
      isLoading={isLoading}
      isOpen={show}
      type={ModalType.SourceChange}
      headerTitle='Expand Search'
      onCloseBtnClicked={handleContinueClick}
      headerIcon={<img onClick={handleNoClick} className='se-close' src={''} />}
      showHeaderIcon={true}
      width={+deleteReportModalWidth}
      onActionBtnClicked={handleNoClick}
      actionBtnText='No'
      actionBtnEnabled={true} 
      souceChange={true}
      >
      <ConfirmationSourcePopup>
        <div className='confirmation-popup'>
          <div>
            <label className='confirmation-message'>
              No results found from the selected source. Would you like to expand your search with
              the Web Search data source?
            </label>
          </div>
        </div>
      </ConfirmationSourcePopup>
    </Modal>
  );
};

const ConfirmationSourcePopup = styled.div`
  .confirmation-popup {
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    .confirmation-message {
      font-family: ${fontInterstate};
      font-size: 14px;
      font-weight: 300;
      line-height: 24px;
      color: #2e2e38;
    }
  }
`;

export default React.memo(ConfirmationSourceModal);